import { styled } from '@mui/material/styles'
import { Grid, Box } from '@mui/material'

export const Wrapper = styled(Grid)(props => `
    width:100%;
    height:auto;
    ${props?.showEdit && `
        overflow:hidden;
    `};
`)

export const SocialMonitorEditWrapper = styled(Box)(({ theme }) => `
    position: fixed;
    top:0;
    left:0;
    z-index:100;
    width:100vw;
    height:100vh;
    display:block;
    background:${theme.palette.background.default};
`)

export const HiddenLoader = styled(Box)(({ theme }) => `
    position: fixed;
    top:0;
    left:0;
    z-index:110;
    width:100vw;
    height:100vh;
    display:none;
    background:rgba(255, 255, 255, 0.2);
`)
